"use strict";
'use es6'; // From MDN: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.escapeRegExp = void 0;

var escapeRegExp = function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
};

exports.escapeRegExp = escapeRegExp;


//////////////////
// WEBPACK FOOTER
// ./js/utils/escapeRegExp.js
// module id = 762
// module chunks = 209 210 211 212